export const INVOICES_SECTION_KEY = 'invoicesSection'
export const ORDER_QUESTIONS_CONST_RATEPAY_ID = 'Ratepay'
